// // Webpack Imports
// import 'bootstrap';
//
// import 'lazysizes';
//
// import 'lazysizes/plugins/parent-fit/ls.parent-fit';
//
// var WebFont = require('webfontloader');
//
// WebFont.load(
//     {
//         google: {
//             // families: ['Open+Sans:400,600,700,800&amp;subset=latin-ext']
//             families: ['Nunito+Sans:300,400,600,700,900&amp;subset=latin-ext']
//         }
//     }
// );
//
// ( function ( $ ) {
// 	'use strict';
//
// 	// JQuery fallback: add title attribute from placeholder
// 	$( 'input, textarea' ).attr( 'title', function () {
// 		return $( this ).attr( 'placeholder' );
// 	} );
//
// 	// Focus Search if Searchform is empty
// 	$( '.search-form' ).on( 'submit', function ( e ) {
// 		var search = $( '#s' );
// 		if ( search.val().length < 1 ) {
// 			e.preventDefault();
// 			search.focus();
// 		}
// 	} );
//
//     $('.text-form form input, .text-form form textarea').on('change', function(){
//     	if($(this).val() == ''){
//     		$(this).removeClass('filled');
// 		}else{
//             $(this).addClass('filled');
// 		}
//     });
//     $('.text-form form select').on('change', function(){
//         if($(this).val() == '' || $(this).val() == 'Wybierz temat'){
//             $(this).parent().removeClass('filled');
//         }else{
//             $(this).parent().addClass('filled');
//         }
//     });
// 	$('.floating-label').each(function(){
// 		var parent = $(this).parent();
// 		var el = $(this).detach();
// 		parent.find('span').append(el);
// 	});
//
//     document.addEventListener( 'wpcf7mailsent', function( event ) {
//     	console.log(event.detail);
//      	$('#contact-form-modal').modal('show');
//     }, false );
//
// }( jQuery ) );



// Webpack Imports
// import 'bootstrap';

import 'lazysizes';

// import 'lazysizes/plugins/parent-fit/ls.parent-fit';

import 'glider-js';

var WebFont = require('webfontloader');

WebFont.load(
	{
		google: {
			families: ['Open+Sans:400,700,800&amp;subset=latin-ext']
		}
	}
);
const homeslider = document.querySelector('.glider-slider');
if(homeslider){
	const glider = new Glider(homeslider, {
		// Mobile-first defaults
		slidesToShow: 1,
		slidesToScroll: 1,
		scrollLock: false,
		dots: '.dots',
		arrows: {
			prev: '.glider-prev',
			next: '.glider-next'
		},
		autoplay: true
	});
	window.addEventListener('load', function () {
		function sliderAuto(slider, miliseconds) {
			slider.isLastSlide = function() {
				return slider.page >= slider.dots.childElementCount - 1;
			};
			var slide = function() {
				slider.slideTimeout = setTimeout(function() {
					function slideTo() {
						return slider.isLastSlide() ? 0 : slider.page + 1;
					}

					slider.scrollItem(slideTo(), true);
				}, miliseconds);
			};
			slider.ele.addEventListener('glider-animated', function(event) {
				window.clearInterval(slider.slideTimeout);
				slide();
			});
			slide();
		}
		sliderAuto(glider, 4000);
	});
}
const whatwedoslider = document.querySelector('.glider-what-we-do');
if(whatwedoslider){
	const glider_what_we_do = new Glider(whatwedoslider, {
		// Mobile-first defaults
		slidesToShow: 1,
		slidesToScroll: 1,
		scrollLock: true,
		dots: '.dots',
		arrows: {
			prev: '.glider-what-we-do-prev',
			next: '.glider-what-we-do-next'
		},
		autoplay: true,
		responsive: [
			{
				// screens greater than >= 775px
				breakpoint: 900,
				settings: {
					// Set to `auto` and provide item width to adjust to viewport
					slidesToShow: 2,
					slidesToScroll: 1,
					itemWidth: 150,
					duration: 0.25
				}
			},{
				// screens greater than >= 1419
				breakpoint: 1301,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1,
					itemWidth: 150,
					duration: 0.25
				}
			}
		]
	});
}

( function ( $ ) {
	'use strict';
	$(document).on('click', '.navbar-toggler', function() {
		$(this).toggleClass('collapsed');
		$(this).parent().find('.navbar-collapse').toggleClass('active');
	});
	$(document).on('click', '.scroll-to', function() {
		console.log($(this).data('scroll'));
		$('html, body').animate({
			scrollTop: $($(this).data('scroll')).offset().top
		}, 2000);
	});
	$(document).on('click', '.faq .title', function() {
		$(this).parent().find('.description').slideToggle();
		$(this).find('.close-open').toggleClass('active');
	});
	$(document).on('click', '.menu-item-has-children', function() {
		$(this).toggleClass('active');
	});
}( jQuery ) );